import React, { useEffect } from 'react';
import RetroMods from '../components/RetroMods';
import Contact from '../components/Contact';
import ContentSlot from '../components/ContentSlot';

const RetroModsPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Retro Console Mods & Game Boy IPS Upgrades | Gamefix Solutions';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Modern upgrades for classic gaming systems. IPS Game Boy screens, USB-C mods, HDMI mods for NES, SNES, N64, PS1, PS2, shell swaps, joystick upgrades & restoration. Get a retro mod quote today.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Modern upgrades for classic gaming systems. IPS Game Boy screens, USB-C mods, HDMI mods for NES, SNES, N64, PS1, PS2, shell swaps, joystick upgrades & restoration. Get a retro mod quote today.';
      document.head.appendChild(meta);
    }

    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <main>
        <div className="pt-24 pb-12 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                <ContentSlot slotId="retro-page-heading" fallback="Retro Mods & Upgrades" contentType="heading" pageSection="retro-page" label="Page Heading" />
              </h1>
              <ContentSlot
                slotId="retro-page-subtitle"
                fallback="Breathe new life into your classic gaming systems with modern upgrades. From IPS screens to USB-C charging, HDMI output for NES, SNES, N64, PlayStation consoles, and custom shells."
                contentType="paragraph"
                as="p"
                pageSection="retro-page"
                label="Page Subtitle"
                className="text-xl text-gray-300 max-w-3xl mx-auto"
              />
            </div>
          </div>
        </div>
        <RetroMods />
        <Contact />
      </main>
    </div>
  );
};

export default RetroModsPage;
